import React, { useEffect, useState } from "react";
import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Popover,
} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import { colors } from "theme";
import {
  CheckboxContainer,
  FilterBadgeWrapper,
  FilterSelectContainer,
} from "pages/Claims/styles";
import { Ptag } from "components/core";

function Filter({ filters, onChange, text, category, showFilterNo = true }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [filterStatusSelected, setFilterStatusSelected] = useState(new Set([]));

  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    // if (filterStatusSelected.size === 0) {
    //   return;
    // }
    onChange(filterStatusSelected);
  }, [filterStatusSelected]);

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const filterHandler = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCheckbox = (status) => {
    if (filterStatusSelected.has(status)) {
      setFilterStatusSelected((prev) => {
        prev.delete(status);
        return new Set(prev);
      });
    } else {
      setFilterStatusSelected((prev) => {
        prev.add(status);
        return new Set(prev);
      });
    }
  };
  const isChecked = (status) => {
    return filterStatusSelected.has(status);
  };
  return (
    <>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        PaperProps={{
          style: {
            border: "1px solid #D0D5DD",
            boxShadow: "none",
            borderRadius: "10px",
          },
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <section>
          <FormControl
            style={{
              margin: "12px",
            }}
            component="fieldset"
            variant="standard"
          >
            <FormGroup>
              {category ? (
                <FilterSelectContainer>
                  {filters.map(([category, options]) => (
                    <div key={category}>
                      <Ptag fontSize="12px" marginBottom="8px">
                        {category}
                      </Ptag>
                      <CheckboxContainer>
                        {options.map((status) => (
                          <FormControlLabel
                            key={status}
                            control={
                              <Checkbox
                                checked={isChecked(status)}
                                onChange={() =>
                                  handleCheckbox(status, category)
                                }
                                name={status}
                                style={{
                                  transform: "scale(1.4)",
                                  color: colors.primaryColor,
                                }}
                              />
                            }
                            label={<Ptag fontSize="12px">{status.replaceAll("_", " ")}</Ptag>}
                          />
                        ))}
                      </CheckboxContainer>
                    </div>
                  ))}
                </FilterSelectContainer>
              ) : (
                filters.map((status) => (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isChecked(status)}
                        onChange={() => handleCheckbox(status)}
                        name={status}
                        style={{
                          transform: "scale(1.4)",
                          color: colors.primaryColor,
                        }}
                      />
                    }
                    label={<Ptag fontSize="12px">{status}</Ptag>}
                  />
                ))
              )}
            </FormGroup>
          </FormControl>
        </section>
      </Popover>
      <Button
        variant="contained"
        startIcon={<FilterListIcon color="black" />}
        onClick={filterHandler}
        sx={{
          backgroundColor: colors.whiteColor,
          fontSize: "14px",
          textTransform: "capitalize",
          fontFamily: "Inter",
          border: "1px solid #D0D5DD",
          color: "#344054",
          boxShadow: "0",
          height: "44px",
          borderRadius: "10px",
          "&:hover": {
            boxShadow: "0",
            backgroundColor: "white",
          },
        }}
      >
        {text || "Status"}
        {filterStatusSelected.size > 0 && showFilterNo && (
          <FilterBadgeWrapper>
            <p>{filterStatusSelected.size}</p>
          </FilterBadgeWrapper>
        )}
      </Button>
    </>
  );
}

export default Filter;
